import { render, staticRenderFns } from "./venueAreaForm.vue?vue&type=template&id=d4628856&scoped=true"
import script from "./venueAreaForm.vue?vue&type=script&lang=js"
export * from "./venueAreaForm.vue?vue&type=script&lang=js"
import style0 from "./venueAreaForm.vue?vue&type=style&index=0&id=d4628856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4628856",
  null
  
)

export default component.exports